export interface Project {
  title: string;
  description: string;
  descriptionEn?: string;
  image: string;
  link: string;
  linkType?: 'github' | 'npm';
  technologies: string[];
}

export const projects: Project[] = [
  {
    title: 'ai-kit',
    description: 'CLI para instalar contexto de engenharia reutilizável para agentes de IA, centralizando skills, padrões, prompts, workflows do Azure DevOps e automações do ciclo entre task e pull request.',
    descriptionEn: 'CLI for installing reusable engineering context for AI agents, bringing together skills, standards, prompts, Azure DevOps workflows, and task-to-pull-request automation.',
    image: '/images/projects/ai-kit.svg',
    link: 'https://www.npmjs.com/package/@angelovcastro9/ai-kit',
    linkType: 'npm',
    technologies: ['Node.js', 'TypeScript', 'AI Agents', 'Codex', 'Claude', 'Azure DevOps']
  },
  {
    title: 'EV-Charge API',
    description: 'API REST desenvolvida em NestJS para gerenciamento de estações de carregamento de veículos elétricos, com sistema de reservas, cálculo de preços e integração com PostgreSQL.',
    descriptionEn: 'NestJS REST API for managing EV charging stations, including reservations, pricing calculations, and PostgreSQL integration.',
    image: '/images/skills/nestjs.svg',
    link: 'https://github.com/AngeloCastro9/EV-Charge-API',
    technologies: ['NestJS', 'TypeScript', 'PostgreSQL', 'Prisma', 'Docker']
  },
  {
    title: 'EV-Charge Web App',
    description: 'Aplicativo web para gerenciamento e interação com a plataforma de carregamento de veículos elétricos, permitindo visualizar estações disponíveis e realizar reservas.',
    descriptionEn: 'Web application for interacting with an electric vehicle charging platform, browsing available stations, and making reservations.',
    image: '/images/skills/react.svg',
    link: 'https://github.com/AngeloCastro9/EV-Charge-Web-App',
    technologies: ['React', 'TypeScript', 'Web App', 'Frontend']
  },
  {
    title: 'BST',
    description: 'Implementação de uma Binary Search Tree (Árvore de Busca Binária) em Python, demonstrando conhecimentos em estruturas de dados e algoritmos.',
    descriptionEn: 'Binary Search Tree implementation in Python, demonstrating data structure and algorithm fundamentals.',
    image: '/images/skills/python.svg',
    link: 'https://github.com/AngeloCastro9/BST',
    technologies: ['Python', 'Algorithms', 'Data Structures']
  },
  {
    title: 'Smart Bill Predictor',
    description: 'Sistema inteligente para previsão de contas e gastos, utilizando técnicas de análise de dados para identificar padrões de consumo.',
    descriptionEn: 'Intelligent expense forecasting system that uses data analysis techniques to identify consumption patterns.',
    image: '/images/skills/typescript.svg',
    link: 'https://github.com/AngeloCastro9/Smart-Bill-Predictor',
    technologies: ['TypeScript', 'Machine Learning', 'Data Analysis', 'Forecasting']
  },
  {
    title: 'Tic Tac Toe IA',
    description: 'Jogo da velha com inteligência artificial implementado em Python, explorando conceitos de IA e algoritmos de jogos.',
    descriptionEn: 'Tic-tac-toe with artificial intelligence implemented in Python, exploring AI concepts and game algorithms.',
    image: '/images/skills/python.svg',
    link: 'https://github.com/AngeloCastro9/Tic_Tac_Toe_IA',
    technologies: ['Python', 'AI', 'Game Development']
  },
];
